//export default function getUnixDateTime(value) {
//  return value * 1000
//}

const getUnixDateTime = (value) => value * 1000

export default getUnixDateTime



// WEBPACK FOOTER //
// ./src/utils/get-unix-date-time.js